import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import logo from "./LogoG.jpg";

const generatePDF = (invoice, orderNumber) => {
  const doc = new jsPDF();

  doc.setFontSize(24);
  doc.text("INVOICE", 10, 20);

  doc.setFontSize(10);
  doc.text(`ORDER NUMBER: #${orderNumber}`, 12, 35);

  doc.addImage(logo, "PNG", 160, -5, 50, 50);
  doc.setDrawColor(169, 169, 169);
  doc.setLineWidth(1);
  doc.line(10, 42, 200, 42);

  doc.setFontSize(12);
  doc.setTextColor(0, 0, 0);

  // Table Customer
  autoTable(doc, {
    startY: 45,
    margin: { left: 10 },
    head: [
      [
        {
          content: "CUSTOMER",
          colSpan: 2,
          styles: { halign: "center", valign: "middle", lineWidth: 0.1 },
        },
      ],
    ],
    body: [
      ["Name", invoice.name],
      ["Company Name", invoice.companyName],
      ["Email Address", invoice.email],
      ["Address", invoice.address],
    ],
    tableWidth: 85,
    theme: "grid",
    styles: {
      halign: "center",
      valign: "middle",
      cellPadding: { top: 0.5, right: 5, bottom: 0.5, left: 5 },
    },
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
      fontSize: 10,
      fontStyle: "none",
    },
  });

  let customerFinalY = doc.previousAutoTable.finalY;

  // Table Quote
  autoTable(doc, {
    startY: 45,
    margin: { left: 105 },
    head: [
      [
        {
          content: "QUOTE DESCRIPTION",
          colSpan: 2,
          styles: { halign: "center", valign: "middle", lineWidth: 0.1 },
        },
      ],
    ],
    body: [
      ["Truck Used", invoice.truck],
      ["Origin", invoice.origin],
      ["Destination", invoice.destination],
      ["Distance (miles)", invoice.distance],
      ["Transit Time", invoice.transitTime],
    ],
    tableWidth: 85,
    theme: "grid",
    styles: {
      halign: "center",
      valign: "middle",
      cellPadding: { top: 0.5, right: 5, bottom: 0.5, left: 5 },
    },
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
      fontSize: 10,
      fontStyle: "none",
    },
  });

  let total = invoice.rows.reduce((acc, row) => acc + parseFloat(row.price), 0);
  // Table Description
  const lastTableFinalY = doc.previousAutoTable.finalY;
  autoTable(doc, {
    startY: lastTableFinalY + 13 || customerFinalY + 13,
    margin: { left: 10 },
    head: [["DESCRIPTION", "PRICE"]],
    body: [
      ...invoice.rows.map((row) => [
        row.description,
        "$ " +
          parseFloat(row.price).toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }),
      ]),
      [
        {
          content: "TOTAL",
          styles: { fontStyle: "bold", textColor: [0, 0, 0] },
        },
        {
          content:
            "$ " +
            total.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }),
          styles: { fontStyle: "bold", textColor: [0, 0, 0] },
        },
      ],
    ],
    tableWidth: 180,
    theme: "grid",
    styles: {
      halign: "center",
      valign: "middle",
      cellPadding: { top: 0.5, right: 5, bottom: 0.5, left: 5 },
    },
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
      fontSize: 10,
      fontStyle: "none",
      lineWidth: 0.1,
    },
  });

  const lastTableFinalYN = doc.previousAutoTable.finalY;
  autoTable(doc, {
    startY: lastTableFinalYN + 5,
    margin: { left: 10 },
    head: [["NOTES"]],
    body: [[invoice.notes]],
    tableWidth: 180,
    theme: "grid",
    styles: {
      halign: "left",
      valign: "middle",
      cellPadding: { top: 0.5, right: 5, bottom: 0.5, left: 5 },
    },
    headStyles: {
      halign: "center",
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
      fontSize: 10,
      fontStyle: "none",
      lineWidth: 0.1,
    },
  });

  const lastTableFinalY2 = doc.previousAutoTable.finalY;
  autoTable(doc, {
    startY: lastTableFinalY2 + 5,
    margin: { left: 10 },
    head: [["SPECIAL NOTES AND INSTRUCTIONS"]],
    body: [
      [
        {
          content:
            "Quote includes: Business to Business transportation, fuel, permits, escorts. \nInsurance for units being transported. Open communication and updates 24/7. \nCoordination and logistics prior to pickup, while transport and after delivery as well. Premium service during entire transaction. \nAbove information is an estimate of services/goods described above. Payment will be collected in prior to provision of services/goods described in this quote.",
          styles: { halign: "left", valign: "middle", lineWidth: 0.1 },
        },
      ],
    ],
    tableWidth: 180,
    theme: "grid",
    styles: {
      halign: "center",
      valign: "middle",
      cellPadding: { top: 0.5, right: 5, bottom: 0.5, left: 5 },
    },
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
      fontSize: 10,
      fontStyle: "none",
      lineWidth: 0.1,
    },
  });

  const lastTableFinalY3 = doc.previousAutoTable.finalY;
  autoTable(doc, {
    startY: lastTableFinalY3 + 2,
    margin: { left: 10 },
    head: [
      [
        {
          content: "PAYMENT METHODS",
          colSpan: 2,
          styles: { halign: "center", valign: "middle", lineWidth: 0.1 },
        },
      ],
    ],
    body: [
      [
        {
          content:
            "IF YOUR PAYMENT IS VIA WIRE/ACH TRANSFER OR ZELLE PLEASE MAKE SURE TO ADD THIS INVOICE # TO YOUR PAYMENT REFERENCE NOTES",
          colSpan: 2,
          styles: { halign: "center", valign: "middle", lineWidth: 0.1 },
        },
      ],

      ["DIRECT DEPOSIT AND ACH", "WIRE TRANSFERS / INTERNATIONAL TRANSFERS"],
      [
        {
          content:
            "Global Transit Solutions LLC\nBank: Chase Bank\nAccount Number: 530532616\nRouting: 322271627\n5600 Wilshire blvd 01 Los Angeles, CA 90036",
          styles: { halign: "left", valign: "middle", lineWidth: 0.1 },
        },
        {
          content:
            "Global Transit Solutions LLC\nBank: Chase Bank\nAccount Number: 530532616\nRouting: 021000021\nSwift Code: CHASUS33\n5600 Wilshire blvd 01 Los Angeles, CA 90036",
          styles: { halign: "left", valign: "middle", lineWidth: 0.1 },
        },
      ],
    ],
    tableWidth: 180,
    theme: "grid",
    styles: {
      halign: "center",
      valign: "middle",
      cellPadding: { top: 0.5, right: 5, bottom: 0.5, left: 5 },
    },
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
      fontSize: 10,
      fontStyle: "none",
      lineWidth: 0.1,
    },
  });

  const lastTableFinalY4 = doc.previousAutoTable.finalY;
  autoTable(doc, {
    startY: lastTableFinalY4,
    margin: { left: 10 },
    body: [
      [
        {
          content:
            "Zelle: admin@globaltransitsol.com\nCredit / Debit Cards: We take all cards at a 4% processing fee",
          styles: { halign: "center", valign: "middle", lineWidth: 0.1 },
        },
      ],
    ],
    tableWidth: 180,
    theme: "grid",
    styles: {
      halign: "center",
      valign: "middle",
      cellPadding: { top: 0.5, right: 5, bottom: 0.5, left: 5 },
    },
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
      fontSize: 12,
      fontStyle: "none",
      lineWidth: 0.1,
    },
  });

  const finalY = doc.autoTable.previous.finalY;

  doc.text(
    "Thank you for your business!",
    doc.internal.pageSize.getWidth() / 2,
    finalY + 40,
    {
      align: "center",
    }
  );

  doc.setFillColor(0, 0, 0);
  doc.rect(20, finalY + 45, doc.internal.pageSize.getWidth() - 40, 5, "F");

  doc.save(`invoice_${orderNumber}.pdf`);
};

export default generatePDF;
